module.exports = __webpack_public_path__ + "static/media/location_feature@3x.d917e832.svg";